export default class HotelGroupServiceCard extends HTMLElement
{
    constructor()
    {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.icon = this.getAttribute('icon');
    }

    static get observedAttributes()
    {
        return ['stylesheet', 'icon'];
    }

    attributeChangedCallback(name, oldValue, newValue)
    {
        if (this.shadowRoot) {
            if (this.shadowRoot.querySelector(`[name="${name}"]`)) {
                this.shadowRoot.querySelector(`[name="${name}"]`).innerHTML = this[name];
            }
        }
    }

    connectedCallback()
    {
        let shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#hotel-group-service-card');
        const instance = t.content.cloneNode(true);

        if (this.stylesheet !== undefined && this.icon !== undefined)
        {
            instance.querySelector('[name="hotel-group-service-icon"]').classList.add(`ci-${this.icon}`);
            instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

            shadowRoot.appendChild(instance);
        }

        return shadowRoot;
    }
}